import Layout from "components/layout";
import NotFound from "pages/NotFound";
import Redirect from "pages/Redirect";
import Welcome from "pages/welcome";
import { RequireAuth } from "./middleware";
import NoAdmin from "pages/NoAdmin";

export const routes = [
  {
    element: Layout,
    children: [
      {
        element: RequireAuth,
        children: [
          {
            path: "/",
            element: Welcome,
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: NotFound,
  },
  {
    path: "/login",
    element: Redirect,
  },
  {
    path: "/admin",
    element: NoAdmin,
  },
];
